<template>
  <div class="cell-arrow-quest" @click.stop="goRoute">
    <div class="row-top">
      <span>
        <span><slot name="icon"></slot></span>
        <span>{{title}}</span>
      </span>
      <span class="cell-ft">
        <slot name="progress"></slot>
      </span>
    </div>
    <div class="row-bottom">
      <!-- <div class="time" v-if="createTime">开始时间 {{item.createTime | formatDate}}</div> -->
      <div class="time" v-if="updateTime !== '0001-01-01T00:00:00Z'">❂&nbsp;更新时间 {{updateTime | formatDate}}</div>
    </div>
  </div>
</template>

<script>
import { isMiniProgram } from '../utils/isMiniProgram'
import { finishedInfo } from '../utils/auth'
import { getStorageItem, updateStorageItem } from '../utils/cache'
import timeFilter from './mixins/timeFilter'
export default {
  props: {
    title: String,
    to: [String, Object],
    updateTime: String
  },
  mixins: [timeFilter],
  methods: {
    goRoute () {
      const auth = getStorageItem('auth')
      if (auth && !auth.agree) {
        setTimeout(() => {
          this.$parent.showConsent = true
        }, 100)
      } else if (this.to && this.$router) {
        let routeName = this.to.name
        let id = this.to.param
        updateStorageItem('followupId', id)
        if (isMiniProgram() && finishedInfo()) {
          window.wx.miniProgram.navigateTo({url: '../' + routeName + '/' + routeName + '?id=' + id})
        } else {
          this.$router.push({name: routeName, query: {id: id}})
        }
      }
    }
  }
}
</script>

<style lang="less">
.cell-arrow-quest {
  position: relative;
  &:after {
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: #eee;
  }
  .row-top {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding-top: 8px;
    padding-left: 15px;
    .cell-ft {
      margin: 0 15px;
      position: relative;
      text-align: right;
      display: flex;
      color: #999999;
      align-items: center;
      &:after {
        content: " ";
        display: inline-block;
        height: 6px;
        width: 6px;
        border-width: 2px 2px 0 0;
        border-color: #C8C8CD;
        border-style: solid;
        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        position: relative;
        top: -2px;
        position: absolute;
        top: 50%;
        margin-top: -4px;
        right: 2px;
      }
    }
    .fa {
      width: 16px;
    }
    .fa-file-word-o {
      color:  #3a90e4; // #42b983;
    }
  }
  .row-bottom {
    font-size: 12px;
    padding-left: 22px;
    padding-bottom: 8px;
    .time {
      color: #666;
    }
  }
}
</style>
